import React from 'react';

import AsyncView from '@/components/AsyncView';
import usePreviewHeader from '@/hooks/usePreviewHeader';
import { useFetchCourseQuery } from '@/modules/corporate/modules/course/graphql/queries/generated/course';
import routes from '@/pages/corporate/routes';

function CoursePreview({ courseId }: { courseId: string }) {
  const [{ data, fetching, error }] = useFetchCourseQuery({ variables: { courseId: courseId } });
  const course = data?.content ?? {};
  const { previewId } = usePreviewHeader({
    content: course,
  });

  return (
    <AsyncView
      data={course}
      error={error}
      fetching={fetching}
      renderData={() => (
        <iframe
          src={`${routes.CoursePreview(
            courseId,
          )}?previewRootBlockId=${previewId}&showPublished=true`}
        />
      )}
    />
  );
}

export default CoursePreview;
